import { render, staticRenderFns } from "./VerticalList.vue?vue&type=template&id=333a5384&scoped=true"
import script from "./VerticalList.vue?vue&type=script&lang=js"
export * from "./VerticalList.vue?vue&type=script&lang=js"
import style0 from "./VerticalList.vue?vue&type=style&index=0&id=333a5384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a5384",
  null
  
)

export default component.exports